import React from 'react'
import { ROOT_PATH } from 'routes/paths'
import { PageWrapperCentralized } from 'styles/common/Common.styles'
import {
  StyledImage,
  Title,
  Text,
  ButtonGoHome,
  ContentContainer
} from './NotFound.styles'
import { useTranslation } from 'i18n'
import { Cdn } from 'utils/assets'
import usePageTitle from 'utils/hooks/use-page-title'
import useA11yEnabled from 'utils/hooks/use-a11y-enabled'

const NotFound = () => {
  const { t } = useTranslation()
  const { a11yEnabled } = useA11yEnabled()

  usePageTitle(t('Página não encontrada'))

  return (
    <PageWrapperCentralized as="main">
      <ContentContainer>
        <StyledImage src={Cdn.getAssetUrl2('e_404/404.png')} />
        <Title>
          {t('O conteúdo que você acessou não existe (ou não está mais aqui).')}
        </Title>
        <Text a11yEnabled={a11yEnabled}>
          {t(
            'Volte para nossa página inicial e descubra novos conteúdos incríveis com a gente!'
          )}
        </Text>
        <ButtonGoHome
          theme={{ type: 'secondary', size: 'large' }}
          text={t('Voltar')}
          onClick={() => (global.location.href = `${ROOT_PATH}`)}
        />
      </ContentContainer>
    </PageWrapperCentralized>
  )
}

export default NotFound
